var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingScaleQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 20.5C29.47 20.5 28.6 21.12 28.21 22H25.29C24.9 21.12 24.03 20.5 23 20.5C21.97 20.5 21.1 21.12 20.71 22H17.79C17.4 21.12 16.53 20.5 15.5 20.5C14.12 20.5 13 21.62 13 23C13 24.38 14.12 25.5 15.5 25.5C16.53 25.5 17.4 24.88 17.79 24H20.71C21.1 24.88 21.97 25.5 23 25.5C24.03 25.5 24.9 24.88 25.29 24H28.21C28.6 24.88 29.47 25.5 30.5 25.5C31.88 25.5 33 24.38 33 23C33 21.62 31.88 20.5 30.5 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingScaleQuestion);
export default __webpack_public_path__ + "static/media/RatingScaleQuestion.7151389e365df43c54a9e305fb5be0f3.svg";
export { ForwardRef as ReactComponent };